<div class="date-wrapper mb-3">
  <div class="header">
    {{ header }} <span *ngIf="keyRequired">*</span>
  </div>

  <div [ngClass]="hasIcon ? 'input-group' : ''">
    <span class="input-group-text" *ngIf="hasIcon">
      <i [ngClass]="resolvedIconClass"></i>
    </span>
    <input
      class="form-control datepicker forminput"
      type="text"
      placeholder="Select Date"
      mwlFlatpickr
      [disableMobile]="true"
      [maxDate]="today"
      [altInput]="true"
      [altFormat]="'d/m/Y'"
      [dateFormat]="'Y-m-d'"
      [ngClass]="{'error-border': showRequiredError}"
      [mode]="'single'"
      [(ngModel)]="selectedDate"
      (ngModelChange)="updateFormattedDate()" />
  </div>
  <img src="assets/DashboardIcon/calendar-icon.svg" class="calendar-icon" alt="Calendar Icon" />

  <div *ngIf="showRequiredError" class="text-danger">
    This field is required
  </div>
</div>

<!-- For debugging, you can display the formatted date -->
<!-- <p *ngIf="formattedDate">Formatted Date: {{ formattedDate }}</p> -->
